module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAECAYAAAB7oZQmAAAAAXNSR0IArs4c6QAAABlJREFUGBlj1Fn24D8DjQETjc0HGz98LAEAP2ACuYjgnroAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/protectplus_britapro_com/images/icon_line_lightblue@2x.png
// module id = 1810
// module chunks = 0